import moment from "moment";
export const RemarkHistory = ({ dataRemarks, onClick, id }) => {
  console.log("dataRemarks", dataRemarks);
  return (
    <div
      className="accordion accordion-toggle-arrow"
      id="remarksHistoryaccordion"
      onClick={onClick}
    >
      <div className="card">
        <div className="card-header">
          <div
            className="card-title collepsed"
            data-toggle="collapse"
            data-target={`#remarksHistory`}
          >
            Remarks History
          </div>
        </div>

        <div
          id={`remarksHistory`}
          className="collapse remarksHistory"
          data-parent="#remarksHistoryaccordion"
        >
          <div className="card-body">
            <div className="main">
              {dataRemarks &&
                dataRemarks?.remarks?.map((remarkObj, index) => {
                  const { remarks, userName, updatedDate, createdDate } =
                    remarkObj;

                  return (
                    <>
                      {/*Loop Start Here*/}
                      <div className="timeline timeline-6 timeline-custom">
                        <div className="w-100">
                          <p className="font-weight-bold text-dark-75 font-size-lg mb-0 ml-3">
                            {userName?.en}
                          </p>
                          <div className="font-weight-mormal font-size-lg timeline-content text-muted pl-3 text-capitalize">
                            {remarks}
                          </div>
                          <p className="font-size-sm font-weight-bold mb-0 ml-3 text-dark-75 text-right mt-3">
                            {(() => {
                              const dateToUse = updatedDate || createdDate;
                              const localDate = moment.utc(dateToUse).local();

                              return (
                                <>
                                  <span className="p-1 px-3 rounded mr-1 bg-success">
                                    {localDate.format("hh:mm A")}
                                  </span>
                                  <span className="bg-light-danger p-1 px-3 ml-1 rounded">
                                    {localDate.format("LL")}
                                  </span>
                                </>
                              );
                            })()}
                          </p>
                        </div>
                      </div>
                      {/*Loop Start End*/}
                      <hr />
                    </>
                  );
                })}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
